import { ReactNode } from 'react';

import { Styles, css, cx } from '@flipster/styled-system/css';
import { ChoiceChipVariant, choiceChip } from '@flipster/styled-system/recipes';

import { useMeasure } from '../../../misc/browser/measure';

export type ChoiceChipVariantType = ChoiceChipVariant['type'];
export interface ChoiceChipProps {
  type?: ChoiceChipVariantType;
  icon?: ReactNode;
  label?: ReactNode;
  badge?: ReactNode;
  selected?: boolean;
  redDot?: boolean;
  onClick?: () => void;
  css?: Styles;
}
export const ChoiceChip = ({
  type = 'rounded',
  icon,
  label,
  badge,
  selected,
  redDot,
  onClick,
  css: cssProps,
}: ChoiceChipProps) => {
  const classes = choiceChip({ selected, type, redDot });
  const [ref, { width, height }] = useMeasure<HTMLButtonElement>();
  const showRedDot = redDot && !selected;
  return (
    <div className={classes.root}>
      <button
        type='button'
        data-active={selected || undefined}
        ref={ref}
        className={cx(classes.container, css(cssProps))}
        style={{
          clipPath: showRedDot
            ? `path("M -2 -2 V ${height + 2} H ${width + 2} V 4.5 H ${width} a 4.5 4.5 0 1 1 -9 0 a 4.5 4.5 0 1 1 9 0 h 2 V -2 Z")`
            : undefined,
        }}
        onClick={onClick}
      >
        {icon && <div className={classes.icon}>{icon}</div>}
        {label != null && <div className={classes.label}>{label}</div>}
        {badge != null && <div className={classes.badge}>{badge}</div>}
      </button>
      {showRedDot && <div className={classes.redDot} />}
    </div>
  );
};
